<!--
 * @LastEditTime: 2020-03-24 13:57:04
 * @Description: 查看详情
 * @Date: 2019-12-31 11:45:33
 * @Author: @虾哔哔
 -->
<template>
	<div class="view-context">
		<el-dialog title="查看详情" :visible.sync="dialogVisible" width="800px" @close="dialogClose()" :close-on-click-modal="false">
			<el-row v-loading="loading">
				<el-col :span="16" class="im_content">
					<!-- 对话列表 -->
					<div class="im_content-groups" style="overflow:auto">
						<ul v-if="data.list.length>0">
							<template v-for="(item, index) in data.list">
								<!-- <li class="im_content-tips" v-if="item.user_type&&item.user_type === 'tips'"><span>{{item.msg_content}}</span></li> -->
								<li class="im_content-msgs" :rule="item.type?1:0" :key="index">
									<div class="im_content-msgs-time">{{item.msg_time}}</div>
									<div class="im_content-msgs-main">
										<i v-if="!item.type" class="im_icon el-icon-user-solid"></i>
										<i v-else class="im_icon iconfont iconkefu"></i>
										<div :class="{'hint':item.msg_content===keyword,'im_content-msgs-msg':true}">
											<span v-if="!item.type" v-html="item.ori_question" @click="tokenDetail($event)"> </span>
											<span v-else v-html="item.answer" @click="tokenDetail($event)"> </span>
										</div>
									</div>
								</li>
							</template>
						</ul>
						<div v-else class="no-data">
							<span>暂无内容</span>
						</div>
					</div>
				</el-col>
				<el-col :span="8" class="tool-p15">
					<el-form>
						<el-form-item label="用户昵称：">
							<span>{{data.user_name}}</span>
						</el-form-item>
						<el-form-item label="会话来源：">
							<span>{{data.channel|findChannelVal}}</span>
						</el-form-item>
						<el-form-item label="会话状态：">
							<span>{{data.status?"已结束":"未结束"}}</span>
						</el-form-item>
						<el-form-item label="开始时间：">
							<span>{{data.start_time}}</span>
						</el-form-item>
						<el-form-item label="结束时间：">
							<span>{{data.end_time}}</span>
						</el-form-item>
						<el-form-item label="会话时长：">
							<span>{{data.duration}}</span>
						</el-form-item>

					</el-form>
				</el-col>
			</el-row>
			<!--  -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";
	const data = {
		list: [],
		user_name: "",
		channel: "fx",
		status: 0,
		start_time: "",
		end_time: "",
		duration: ""
	};
	const channelList = [
		{
			value: "all",
			label: "全部来源"
		},
		{
			value: "wsc",
			label: "微商城H5"
		},
		{
			value: "wechat",
			label: "微信公众号"
		},
		{
			value: "mmp",
			label: "微信小程序"
		},
		{
			value: "yzWeapp",
			label: "有赞小程序公共版"
		},
		{
			value: "spotlight",
			label: "有赞精选小程序"
		},
		{
			value: "guang",
			label: "爱逛直播"
		},
		{
			value: "tripartite",
			label: "App开店"
		},
		{
			value: "fx",
			label: "分销"
		},
		{
			value: "wxdkf",
			label: "微小店"
		},
		{
			value: "ebottest",
			label: "测试窗口"
		}
	];
	export default {
		props: {
			keyword: {
				type: String,
				default: ""
			}
		},
		data() {
			return {
				dialogVisible: false,
				data: JSON.parse(JSON.stringify(data)),
				loading: true
			};
		},
		computed: {
			...mapGetters(["shopId"])
		},
		filters: {
			findChannelVal(key) {
				try {
					return channelList.filter(item => {
						return item.value === key;
					})[0].label;
				} catch (error) {}
			}
		},
		methods: {
			tokenDetail(e){
				if (e.target.nodeName === 'IMG') {
					let src = e.target.getAttribute('src');
					window.open(src)
				}
			},
			openDialog(data) {
				this.dialogVisible = true;
				let params = {
					authority_id: this.shopId,
					session_id: data.session_id
				};
				this.$store
					.dispatch("DataLog/getSessionReportDetail", params)
					.then(res => {
						console.log(res);
						if (res.data.code === 2000) {
							this.data = res.data.data;
							this.loading = false;
							this.$message.success({
								message: res.data.desc,
								center: true
							});
						} 
					});
			},
			dialogClose() {
				// this.data = JSON.parse(JSON.stringify(data));
				this.loading = true;
			}
		}
	};
</script>

<style lang="less" scoped>
@deep:~">>>";
	.view-context {
		// content
		.im_content {
			position: relative;
			display: flex;
			flex-direction: column;
			height: 400px;
			background-color: #f5f5f5;
			@{deep}.el-scrollbar__thumb{
				display: none;
			}
			.im_content-groups {
				flex: 1;
				padding: 0 15px;
				// @{deep} .el-scrollbar__view {
				// 	min-height: 100%;
				// 	display: flex;
				// 	justify-content: center;
				// 	align-items: center;
				// }
				ul {
					margin: 0;
					padding: 0;
					/* 信息条样式--通用设置 */
					.im_content-tips {
						margin: 25px 0;
						text-align: center;
						span {
							color: #c0c4cc;
							font-size: 12px;
						}
					}
					.im_content-msgs {
						margin: 25px 0;
						.im_content-msgs-time {
							margin: 10px 0;
							color: #909399;
							text-align: center;
							font-size: 12px;
						}
						.im_content-msgs-main {
							display: flex;
							align-items: flex-end;
							.im_icon {
								width: 30px;
								height: 30px;
								border-radius: 100%;
								font-size: 30px;
							}
							.im_content-msgs-msg {
								flex: auto;
								flex-grow: 0;
								flex-shrink: 1;
								padding: 10px 15px;
								border-radius: 15px;
								background-color: #fff;
								word-break: break-all;
								font-size: 13px;
								line-height: 1.5;
								&.hint {
									background-color: #ef2a2a !important;
								}
								@{deep}img{
										max-width: 300px;
									}
							}
						}
						//
						&[rule="0"] {
							.im_content-msgs-time {
							}
							.im_content-msgs-main {
								flex-direction: row-reverse;
								.im_content-msgs-msg {
									margin-right: 10px;
									margin-left: 40px;
									border-bottom-right-radius: 5px;
									background-color: #409eff;
									color: #fff;
									@{deep}img{
										max-width: 200px;
									}
								}
							}
						}
						//
						&[rule="1"] {
							.im_content-msgs-time {
							}
							.im_content-msgs-main {
								.im_content-msgs-msg {
									margin-right: 40px;
									margin-left: 10px;
									border-bottom-left-radius: 5px;
									@{deep}img{
										max-width: 300px;
									}
								}
							}
						}
					}
				}
				//
				.no-data {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 100%;
					height: 100%;
				}
			}
		}
	}
</style>
<style>
.im_content-msgs-msg img {
	max-width: 300px i !important;
}
</style>
